__turbopack_context__.v({
  "behindNavBar": "behindnavbar-module-scss-module__8Pa__W__behindNavBar",
});
